import { Controller } from "@hotwired/stimulus"
import 'mmenu-js/dist/mmenu.css'
import Mmenu from 'mmenu-js';

export default class extends Controller {
  connect() {
    if (window.innerWidth < 1024) {
    new Mmenu( "#menu", {
      "offCanvas": {
         "page": {
          selector: "#page"
        }
      },
      "theme": "dark"
   });
    }
    if (window.innerWidth < 1024) {
        // Проверяем, существует ли element #menu на странице
       
      // document.addEventListener("turbo:load", function () {
      //   // console.log("Turbo, hid");
      //   // menu2 = document.querySelector("#menu2")
      //   // menu2.classList.add("hidden");
      //   // // current.closest(".mm-panel")
      // });
      // document.addEventListener("DOMContentLoaded", function () {
      //   // console.log("DOM");
      // hooks: {
      //   "openPanel:after": (panel) => {
      //     // menu2.classList.remove("hidden");
      //     // menu2.closest(".mm-panel")
      //   }
      // },
      // });
     
        // Проверяем, существует ли element #menu2 на странице
        
          // console.log("DDD");
          // Инициализация второго меню, если #menu2 существует
         
          // if (menu2) { // Убедитесь, что menu2 действительно существует
          //   // menu2.classList.remove("hidden"); // Замените "имя-класса-для-удаления" на имя класса, который вы хотите удалить
          // }
        
     
    }

  }
}
